import RecordSpace from './RecordSpace.vue'
export default RecordSpace



// WEBPACK FOOTER //
// ./src/views/system/recordSpace/index.js